export default __webpack_public_path__ + "static/media/home.221abcc6.svg";